var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-2 mb-3"},[_c('div',{staticClass:"col-3 pt-2 mb-2"}),_c('div',{staticClass:"col-12"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }